import React from "react";

const Spotify = ({fill}) => {
  return (
    <svg
      className="social-icon-fill"
      width={30}
      height={30}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 1.75C7.68139 1.75 1.75 7.68252 1.75 15C1.75 22.3175 7.68139 28.25 15 28.25C22.3186 28.25 28.25 22.3175 28.25 15C28.25 7.68252 22.3186 1.75 15 1.75ZM0.25 15C0.25 6.85418 6.85287 0.25 15 0.25C23.1471 0.25 29.75 6.85418 29.75 15C29.75 23.1458 23.1471 29.75 15 29.75C6.85287 29.75 0.25 23.1458 0.25 15ZM15.4714 10.3453C12.198 10.0773 8.86216 10.4773 6.11942 11.4463L5.61971 10.032C8.58288 8.98505 12.1332 8.56694 15.5938 8.85035C19.0518 9.13354 22.4772 10.1221 25.1605 11.9448L24.3177 13.1857C21.9039 11.5461 18.7474 10.6136 15.4714 10.3453ZM22.4757 18.0441C18.4175 15.1309 13.534 14.5134 6.60892 15.7386L6.3476 14.2615C13.4737 13.0008 18.8308 13.5811 23.3504 16.8255L22.4757 18.0441ZM14.1328 19.527C11.7187 19.2898 9.26409 19.5021 7.26459 19.9895L6.90932 18.5322C9.06965 18.0056 11.694 17.7802 14.2794 18.0342C16.8601 18.2878 19.458 19.0248 21.5183 20.4734L20.6556 21.7005C18.8738 20.4477 16.5516 19.7647 14.1328 19.527Z"
        fill={fill}
      />
    </svg>
  );
};

export default Spotify;
